import React from 'react';

const Badge = ({ variant = 'info', children, className = '' }) => {
  const variantClasses = {
    success: 'bg-green-500/20 text-green-500 border-green-500',
    danger: 'bg-red-500/20 text-red-500 border-red-500',
    warning: 'bg-yellow-500/20 text-yellow-500 border-yellow-500',
    info: 'bg-blue-500/20 text-blue-500 border-blue-500',
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${variantClasses[variant]} ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
